<template>
  <div class="grid-x flex-grow">
    <div class="cell auto cell-block-y flex flex-col flex-grow">

      <div class="flex flex-col">

        <div class="flex justify-end mb-4">
          <button
            class="btn btn-primary"
            @click="createAdmin"
          >
            Добавить администратора
          </button>
        </div>

        <Loading :loading="waitPending">
          <Table
            :columns="columns"
            :rows="payload"
            :row-style-class="() => 'cursor-pointer'"
            :busy="waitPending"
            @on-row-click="onRowClick"
          />
        </Loading>

      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Table from '@/components/Table.vue';
import Loading from '@/components/Loading.vue';

export default {
  components: {
    Table,
    Loading,
  },

  computed: {
    ...mapState({
      admins: (state) => state.settings.admins,
    }),

    payload() {
      return this.admins.map((admin) => ({
        ...admin,
        roleLabel: admin.role === 'super_admin' ? 'Суперадминистратор' : 'Администратор',
        accessLabel: admin.role === 'super_admin'
          ? 'Полный доступ'
          : `${(admin.accessPermissions || []).length} прав`,
      }));
    },

    columns() {
      return [
        { label: '№', field: 'id', sortable: false },
        { label: 'ФИО', field: 'name', sortable: false },
        { label: 'Роль', field: 'roleLabel', sortable: false },
        { label: 'Доступ', field: 'accessLabel', sortable: false },
        { label: 'Статус', field: 'active', sortable: false },
      ];
    },

    waitPending() {
      return this.$wait.is('fetch.admins');
    },
  },

  methods: {
    ...mapActions({
      fetch: 'settings/ACT_FETCH_ADMINS',
    }),

    createAdmin() {
      this.$router.push({
        name: 'settings.admins.create',
      });
    },

    onRowClick({ row }) {
      const { id } = row;
      this.$router.push({
        name: 'settings.admins.edit',
        params: { id },
      });
    },
  },

  mounted() {
    this.fetch();
  },
};
</script>
